import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AppScope } from '@klickdata/core/resource';

@Component({
    selector: 'app-main-catalog-ecourses',
    templateUrl: './main-catalog-ecourses.component.html',
    styleUrls: ['./main-catalog-ecourses.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainCatalogEcoursesComponent implements OnInit {
    AppScope = AppScope;
    constructor() {}

    ngOnInit(): void {}
}
